import React from 'react';
import { useDispatch } from 'react-redux';
import Page from '../../../page/index';
import ApiIntegrationsPage from './ApiIntegrationsPage';
import { setScreen } from '../../../../redux/connectedComponent/uiFactory/uiFactory.slice' 
import { screens } from '../../../config/uiFactory.config'
import SolutionHeader from '../../SolutionHeader/SolutionHeader';
import {resetState} from '../../../../redux/connectedComponent/ManageIntegrationsV2/ManageIntegrationsV2.slice';
import {resetConfigurations} from '../../../../redux/connectedComponent/configurations/Configurations.slice';
import {resetState as resetAPIIntegrationsState} from "../../../../redux/connectedComponent/apiIntegrations/apiIntegration.slice";

const NewApiIntegrationsPage = ({solutionData = {overview: {}},subscriptionData ={},selectedPlanId='', ...props}) => {
  const dispatch = useDispatch();
const onBackButtonClickHandler = () => {
  dispatch(resetAPIIntegrationsState());
  dispatch(resetConfigurations());
  dispatch(resetState());
  dispatch(setScreen({screen: screens.SUBSCRIPTION_MANAGEMENT}));
};

  return (
    <Page>
      <SolutionHeader
          solutionData={solutionData} 
          onBackButtonClickHandler={onBackButtonClickHandler}
          appName={solutionData?.displayName} 
          publisherName={solutionData?.orgName}
          {...props}
        />
      <ApiIntegrationsPage solutionData={solutionData} subscriptionData={subscriptionData} selectedPlanId={selectedPlanId} {...props} />
    </Page>
  );
};
export default NewApiIntegrationsPage;
